import React, { useRef, useEffect } from 'react';
import ScriptLoader from 'react-script-loader-hoc';

const HUBSPOT_ID = 6711345;

import css from './hubspot-form.module.scss';

export const HubspotLoader = ScriptLoader('https://js.hsforms.net/forms/v2.js')(
  ({ scriptsLoadedSuccessfully: loaded, children }) => {
    return loaded ? children : null;
  },
);

export const HubspotForm = ({ formId, ...restProps }) => {
  const containerRef = useRef(null);
  useEffect(() => {
    const poll = window.setInterval(() => {
      if (window?.hbspt?.forms) {
        window.clearInterval(poll);
        // // stub jQuery so hbspt can catch form submission
        // window.jQuery = function ($elem) {
        //   return {
        //     ...$elem,
        //     jquery: this,
        //     change(handler) {
        //       $elem.addEventListener('change', handler);
        //     },
        //   };
        // };
        //@ts-ignore
        window.dataLayer = window.dataLayer || [];
        //@ts-ignore
        window.hbspt.forms.create({
          portalId: HUBSPOT_ID,
          formId,
          target: `#hbspt-form--${formId}`,
          // onFormSubmitted() {
          //   if (adConversionLabel) {
          //     //@ts-ignore
          //     window.dataLayer.push({
          //       event: 'Ad Conversion',
          //       adConversionLabel,
          //     });
          //   }
          // },
        });
      }
    }, 250);
  }, [containerRef]);
  return <div ref={containerRef} className={css.container} id={`hbspt-form--${formId}`} {...restProps} />;
};
